import React from 'react';
import './App.css';
import Section from "./Section/Section";

function App() {
  return (
      <>
      <Section/>
      </>

  );
}

export default App;
